import algoliasearch from 'algoliasearch/lite'
/**
 *
 * @param {*} args
 * @param {Cookie Name userSub} {name}
 * @param {Cookie Value array of all api keys} {value}
 * @param {Cookie expire time, 1 week from the time that cookie created} args
 */
function SetCookie ({ ...args }) {
  const { name, value, expireTime } = { ...args }
  var expires = 0
  if (expireTime < 0) {
    const now = new Date()
    expires = now.getTime() + expireTime // 7 days expiration time
  } else {
    expires = expireTime
  }
  const cookieString = `${name}=${escape(value)};expires=${expires};`
  document.cookie = cookieString
}
/**
 * @param {Cookie name{userSub} to retrieve the values} name
 *
 */
function GetCookie ({ ...args }) {
  const { name } = { ...args }
  let allCookies = ' ' + document.cookie
  let search = ' ' + name + '='
  let setStr = null
  let offset = 0
  let end = 0
  if (allCookies.length > 0) {
    offset = allCookies.indexOf(search)
    if (offset !== -1) {
      offset += search.length
      end = allCookies.indexOf(';', offset)
      if (end === -1) {
        end = allCookies.length
      }
      setStr = unescape(allCookies.substring(offset, end))
      return setStr
    } else {
      return false
    }
  } else {
    return false
  }
}
// Mock api call for api_keys
function getApiKeys () {
  return new Promise((resolve, reject) => {
    return setTimeout(() => resolve(['prod_shipments:e5b8a01d8c6ca064424f71e630360d15', 'prod_orders:e5b8a01d8c6ca064424f71e630360d15', 'prod_organizations:e5b8a01d8c6ca064424f71e630360d15']), 1000)
  })
}
// Actual plugin
export default {
  /**
   *
   * @param {*} Vue
   * @param {pass store to plugin to retrieve the loggedin user userSub} {store}
   * @param {*} opts
   */
  install (Vue, { store }, opts) {
    Vue.user = {
      name: null
    }
    /**
     * @param {based on the index retrieve the proper api_key(shipments, orders, companies) } index
     */
    Vue.prototype.$AlgoliaSecuredSearchGetKeyPerIndex = function (index) {
      var userCookie = GetCookie({ name: Vue.user.name })
      var API_KEY = ''
      if (userCookie) {
        userCookie.split(',').forEach((key) => {
          if (key.indexOf(index) !== -1) {
            API_KEY = key.split(':')[1]
          }
        })
      }
      // if process of retrieving api key fails return null
      if (API_KEY === '') {
        return null
      } else {
        return algoliasearch(
          '9N5LGLZPRT',
          API_KEY
        )
      }
    }
    // Set cookie with api keys if not exist
    Vue.prototype.$AlgoliaSecuredSearchInitialize = async function () {
      Vue.user.name = store.getters['cognito/userSub']
      var userCookie = GetCookie({ name: Vue.user.name })
      if (!userCookie) {
        // Call back end to get keys
        getApiKeys().then((data) => {
          SetCookie({ name: Vue.user.name, value: data, expireTime: (7 * 24 * 60 * 60 * 1000) })
        }).catch((error) => {
          console.log(error)
        })
      }
    }
    // Delete cookie for current logged in user
    Vue.prototype.$AlgoliaSecuredSearchDeleteCookie = function () {
      SetCookie({
        name: Vue.user.name,
        value: [],
        expireTime: -999999
      })
    }
  }
}
